import { API_V1_PATH } from "../config";
import { request } from "../request";
export const uploadImage = (file) => {
    const body = new FormData();
    body.append("file", file, file.name);
    return request(`${API_V1_PATH}/image`, {
        method: "POST",
        body
    });
};
